import { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import axios from "../../api/axiosClient";
import { useNavigate } from "react-router-dom";
import BarcodeIcon from "./BarcodeIcon";
import MenuActions from "./MenuActions";
import { useIntl } from "react-intl";
import DiagramModal from "../Modals/DiagramModal";
import BoxInQCModal from "../Modals/BoxInQCModal";
import { useLoading } from "../LoadingContext";
import { useSelector } from "react-redux";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
  getFile,
} from "../../services/serviceBase";
import NoteModal from "../Modals/NoteModal";
import RetunFileRelatedModal from "../Modals/RetunFileRelatedModal";
import AttachmentModal from "../Modals/AttachmentModal";
import BoxInModal from "../Modals/BoxInModal";
import BoxQCModal from "../Modals/BoxQCModal";
import toast from "react-hot-toast";
import AttachmentBoxInQCModal from "../Modals/AttachmentBoxInQCModal";
import ForceClosureModal from "../Modals/ForceClosureModal";
import ForceInTransitModal from "../Modals/ForceInTransitModal";
import DownloadExcelModal from "../Modals/DownloadExcelModal";
import { getExcelReports, runReportDownload, getExcelReportFieldSets } from "../../services/exportService";

const ReturnFileActions = (props) => {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const [canForceInTransit, setCanForceInTransit] = useState(false);
  const [canForceClosing, setCanForceClosing] = useState(false);

    useEffect(() => {
      checkForceInTransitEnabled();
      checkForceClosingEnabled();
    }, []);
  
  //#region BoxIn + BoxQC
  const [openBoxInDetailsModal, setOpenBoxInDetailsModal] = useState(false);
  const handleCloseBoxInDetailsModal = () => setOpenBoxInDetailsModal(false);

  const handleOpenBoxInDetailsModal = (e, idReturnFileHead) => {
    e.preventDefault();
    setOpenBoxInDetailsModal(true);
  };

  const [openBoxQCDetailsModal, setOpenBoxQCDetailsModal] = useState(false);
  const handleCloseBoxQCDetailsModal = () => setOpenBoxQCDetailsModal(false);

  const handleOpenBoxQCDetailsModal = (e, idReturnFileHead) => {
    e.preventDefault();
    setOpenBoxQCDetailsModal(true);
  };
  //#endregion

  //#region Attachments
  const [openModalAttachments, setopenModalAttachments] = useState(false);
  const handleOpenModalAttachments = () => setopenModalAttachments(true);
  const handleCloseModalAttachments = () => setopenModalAttachments(false);
  //#endregion

  //#region Actions
  const [openModalDiagram, setopenModalDiagram] = useState(false);
  const handleCloseModalDiagram = () => setopenModalDiagram(false);

  const [openModalBoxInQC, setOpenModalBoxInQC] = useState(false);
  const handleCloseModalBoxInQC = () => setOpenModalBoxInQC(false);

  const [downloadLink, setDownloadLink] = useState("");
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const [canEnableCheckInAtWh, setCanEnableCheckInAtWh] = useState(false);

  useEffect(() => {
    checkInAtWhEnabled();
  }, []);

  const isEnableToBoxKO = props.rfState == "CheckInAtWarehouse";

  const handleDiagram = () => {
    setopenModalDiagram(true);
  };

  const handleRAForcedClosing = () => {
    handleOpenModalForceClosure();
  };

  const handleForceInTransit = () => {
    handleOpenModalForceInTransit();
  };

  const handleCheckInAtWH = () => {
    navigate(`${process.env.PUBLIC_URL}/CheckIn/${props.idReturnFileHead}`);
  };

  const handleOpenQualityCheck = () => {
    navigate(`${process.env.PUBLIC_URL}/QCDetail/${props.idReturnFileHead}`);
  };

  const handleOpenBoxInQCModal = () => {
    //setOpenModalBoxInQC(true);
    navigate(`${process.env.PUBLIC_URL}/BoxInQC/${props.idReturnFileHead}`);
  };

  const menuActions = [
    {
      Name: intl.formatMessage({ id: "RADetails.Diagram" }),
      Action: handleDiagram,
    },
    {
      Name: intl.formatMessage({ id: "RADetails.ForcedClosing" }),
      Action: handleRAForcedClosing,
      Display: canForceClosing ? "" : "none",
    },
    {
      Name: intl.formatMessage({ id: "RADetails.BoxKO" }),
      Action: handleOpenBoxInQCModal,
      Display: !isEnableToBoxKO ? "none" : "",
    },
    {
      Name: intl.formatMessage({ id: "CheckIn.CheckInAtWh" }),
      Action: handleCheckInAtWH,
      Display: canEnableCheckInAtWh ? "" : "none",
    },
    {
      Name: intl.formatMessage({ id: "RADetails.ForceInTransit" }),
      Action: handleForceInTransit,
      Display: canForceInTransit ? "" : "none",
    }
  ];
  //#endregion

  //#region RelatedRa + WorkableRA
  const [openModalRealtedRa, setopenModalRealtedRa] = useState(false);
  const handleOpenModalRelatedRA = () => setopenModalRealtedRa(true);
  const handleCloseModalRelatedRA = () => setopenModalRealtedRa(false);

  const handleRelatedRaClick = () => {
    handleOpenModalRelatedRA();
  };
  //#endregion

  //#region Note
  const [openModalNote, setopenModalNote] = useState(false);
  const [modalNoteHeader, setmodalNoteHeader] = useState("");
  const [modalNoteContent, setmodalNoteContent] = useState("");
  const handleOpenModalNote = () => setopenModalNote(true);
  const handleCloseModalNote = () => setopenModalNote(false);

  const handleRaHeadNote = () => {
    setmodalNoteHeader(intl.formatMessage({ id: "RA.HeadNote" }));
    getRAHeadNote();
  };

  const getRAHeadNote = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/headnote")
      .then((response) => {
        setLoading(false);
        setmodalNoteContent(response.data);
        handleOpenModalNote();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleShimpentNote = () => {
    setmodalNoteHeader(intl.formatMessage({ id: "RA.ShipmentNote" }));
    getRAShipmentNote();
  };

  const getRAShipmentNote = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/shipmentnote")
      .then((response) => {
        setLoading(false);
        setmodalNoteContent(response.data);
        handleOpenModalNote();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const menuNotes = [
    {
      Name: intl.formatMessage({ id: "RA.HeadNote" }),
      Action: handleRaHeadNote,
    },
    {
      Name: intl.formatMessage({ id: "RA.ShipmentNote" }),
      Action: handleShimpentNote,
    },
  ];
  //#endregion

  //#region Reports

  const handleRaDocumentReport = () => {
    setLoading(true);
    var url = "/returnfiles/" + props.idReturnFileHead + "/reports/RAReport";
    getFile(
      url,
      (response) => {
        setLoading(false);
        var filename = response.name;
        addDownloadLinkToDocument(
          response,
          "application/octet-stream",
          filename
        );
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      },
      null
    );
  };

  const handleShipmentDocument = () => {
    setLoading(true);
    var url = "/returnfiles/" + props.idReturnFileHead + "/reports/SDCReport";
    getFile(
      url,
      (response) => {
        setLoading(false);
        var filename = response.name;
        addDownloadLinkToDocument(
          response,
          "application/octet-stream",
          filename
        );
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      },
      null
    );
  };

  const handleBoxLabelCustomerDocument = () => {
    setLoading(true);
    var url = "/returnfiles/" + props.idReturnFileHead + "/reports/BLCReport";
    getFile(
      url,
      (response) => {
        setLoading(false);
        var filename = response.name;
        addDownloadLinkToDocument(
          response,
          "application/octet-stream",
          filename
        );
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      },
      null
    );
  };

  const handleDefectsPDFDocument = () => {
    setLoading(true);
    var url =
      "/returnfiles/" + props.idReturnFileHead + "/reports/DefectsPDFReport";
    getFile(
      url,
      (response) => {
        setLoading(false);
        var filename = response.name;
        addDownloadLinkToDocument(
          response,
          "application/octet-stream",
          filename
        );
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      },
      null
    );
  };

  const handleDefectsExcelDocument = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/reports/DefectsExcelReport")
      .then((response) => {
        setLoading(false);
        setDownloadLink(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const menuReports = [
    {
      Name: intl.formatMessage({ id: "RADetails.RADocument" }),
      Action: handleRaDocumentReport,
    },
    {
      Name: intl.formatMessage({ id: "RADetails.ShippingDocument" }),
      Action: handleShipmentDocument,
    },
    {
      Name: intl.formatMessage({ id: "RADetails.BoxLabelCustomer" }),
      Action: handleBoxLabelCustomerDocument,
    },
    {
      Name: intl.formatMessage({ id: "RADetails.DefectsPDF" }),
      Action: handleDefectsPDFDocument,
    },
    {
      Name: intl.formatMessage({ id: "RADetails.DefectsExcel" }),
      Action: handleDefectsExcelDocument,
    }
  ];
  //#endregion

  //#region Fire Barcode
  const [filterBarcodeValue, setFilterBarcodeValue] = useState("");

  const handleBarcodeFilterChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setFilterBarcodeValue(barcode);
    }
  };
  //#endregion

  const isUrgentClickHandler = () => {
    const isUrgent = !props.detailsHeader?.isUrgent;
 
    setLoading(true);
    let url = "returnfiles/" + props.detailsHeader?.idReturnFileHead + "/" + isUrgent;
    axios
        .put(url)
        .then(() => {
            setLoading(false);
            props.setIsUrgent(isUrgent);
            toast.success(intl.formatMessage({ id: "RADetails.Saved" }));
        })
        .catch((error) => {
            setLoading(false);
        });
  }

  //#region ForceClosure
  const [openModalForceClosure, setopenModalForceClosure] = useState(false);
  const handleOpenModalForceClosure = () => setopenModalForceClosure(true);
  const handleCloseModalForceClosure = () => setopenModalForceClosure(false);

  const checkForceClosingEnabled = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/forceclosing")
      .then((response) => {
        setLoading(false);
        setCanForceClosing(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };
  //#endregion

  //#region ForceInTransit
  const checkForceInTransitEnabled = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/forceintransit")
      .then((response) => {
        setLoading(false);
        setCanForceInTransit(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const [openModalForceInTransit, setopenModalForceInTransit] = useState(false);
  const handleOpenModalForceInTransit = () => setopenModalForceInTransit(true);
  const handleCloseModalForceInTransit = () => setopenModalForceInTransit(false);
  //#endregion

  //#region CheckInAtWarehouse
  const checkInAtWhEnabled = () => {
    var isEnabled = false;
    if (props.detailsHeader?.rfStateCode == "InTransit") {
      if (!props.detailsHeader?.isTriangulation && props.withStealthFlow) {
        isEnabled = true;
      } else if (props.detailsHeader?.affinityGroup == "Packaging") {
        isEnabled = true;
      }
    }

    setCanEnableCheckInAtWh(isEnabled);
  };
  //#endregion

  return (
    <div id='actions'>
      <Card sx={{ mt: 1, pt: 0.5, pb: 0.5 }} className="apeDarkGreyBackground">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1.5}>
            <Grid item md="auto" xs textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={(e) => {
                  handleOpenBoxInDetailsModal(e, props.idReturnFileHead);
                }}
                disableRipple={true}
              >
                {" "}
                [{intl.formatMessage({ id: "BoxInDetails.Title" })}]{" "}
              </Button>
            </Grid>
            <Grid item md="auto" xs textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={(e) => {
                  handleOpenBoxQCDetailsModal(e, props.idReturnFileHead);
                }}
                disableRipple={true}
                disabled={!props.enableBoxQCButton}
              >
                {" "}
                [{intl.formatMessage({ id: "BoxQCDetails.Title" })}]{" "}
              </Button>
            </Grid>
            <div style={{ margin: "auto" }}></div>
            {props.showSKUSearch !== null && props.showSKUSearch ? (
              <>
                <Grid item md={2} xs={12}>
                  <TextField
                    variant="outlined"
                    sx={{ backgroundColor: "white", borderRadius: "0" }}
                    placeholder={intl.formatMessage({
                      id: "RADetails.ArticleBarcode",
                    })}
                    size="small"
                    value={filterBarcodeValue}
                    onChange={(e) => {
                      handleBarcodeFilterChange(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <BarcodeIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item md="auto" xs>
                  <Button
                    sx={{ color: "white", textAlign: "left" }}
                    onClick={(e) => {
                      props.handleBarcodeFilterInputChange(filterBarcodeValue);
                    }}
                    disableRipple={true}
                  >
                    {" "}
                    [{intl.formatMessage({ id: "General.Search" })}]{" "}
                  </Button>
                </Grid>
              </>
            ) : (
              ""
            )}

            <Grid item md="auto" xs>
                <Grid container >
                    <Checkbox
                        onClick={isUrgentClickHandler}
                        checked={props.detailsHeader?.isUrgent}
                    />
                    <Typography variant="subtitle2" sx={{ color: "white", mt: 1 }}>
                        {intl.formatMessage({ id: "RADetails.IsUrgent", })}
                    </Typography>
                </Grid>
            </Grid>

            <div style={{ margin: "auto" }}></div>
            <Grid item md="auto" xs textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={(e) => {
                  handleOpenModalAttachments(e, props.idReturnFileHead);
                }}
                disableRipple={true}
              >
                {" "}
                [{intl.formatMessage({ id: "RADetails.Attachments" })}]{" "}
              </Button>
            </Grid>
            <Grid item md="auto" xs textAlign="center">
              <MenuActions
                buttonName={intl.formatMessage({ id: "RADetails.Actions" })}
                menuActions={menuActions}
              />
            </Grid>
            <Grid item md="auto" xs textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={handleRelatedRaClick}
                disableRipple={true}
              >
                {" "}
                [{intl.formatMessage({ id: "RADetails.RelatedRA" })}]{" "}
              </Button>
            </Grid>
            <Grid item md="auto" xs textAlign="center">
              <MenuActions
                buttonName={intl.formatMessage({ id: "RADetails.Notes" })}
                menuActions={menuNotes}
              />
            </Grid>
            <Grid item md="auto" xs textAlign="center">
              <MenuActions
                buttonName={intl.formatMessage({ id: "RADetails.Prints" })}
                menuActions={menuReports}
              />{" "}
            </Grid>
          </Grid>
        </Box>
      </Card>

      <BoxInModal
        openModal={openBoxInDetailsModal}
        handleCloseModal={handleCloseBoxInDetailsModal}
        idReturnFileHead={props.idReturnFileHead}
      />

      <BoxQCModal
        openModal={openBoxQCDetailsModal}
        handleCloseModal={handleCloseBoxQCDetailsModal}
        idReturnFileHead={props.idReturnFileHead}
      />

      <AttachmentModal
        openModal={openModalAttachments}
        handleCloseModal={handleCloseModalAttachments}
        idReturnFileHead={props.idReturnFileHead}
      />

      <DiagramModal
        openModal={openModalDiagram}
        handleCloseModal={handleCloseModalDiagram}
        idReturnFileHead={props.idReturnFileHead}
      />

      <RetunFileRelatedModal
        openModal={openModalRealtedRa}
        handleCloseModal={handleCloseModalRelatedRA}
        idReturnFileHead={props.idReturnFileHead}
      />

      <NoteModal
        openModal={openModalNote}
        handleCloseModal={handleCloseModalNote}
        modalNoteHeader={modalNoteHeader}
        modalNoteContent={modalNoteContent}
      />

      <BoxInQCModal
        openModal={openModalBoxInQC}
        handleCloseModal={handleCloseModalBoxInQC}
        idReturnFileHead={props.idReturnFileHead}
        returnFileKey={props.returnFileKey}
      />      

      <ForceClosureModal
        openModal={openModalForceClosure}
        handleCloseModal={handleCloseModalForceClosure}
        idReturnFileHead={props.idReturnFileHead}
      />

      <ForceInTransitModal
        openModal={openModalForceInTransit}
        handleCloseModal={handleCloseModalForceInTransit}
        idReturnFileHead={props.idReturnFileHead}
        returnFileKey={props.returnFileKey}
      />

      <DownloadExcelModal
        downloadLink={downloadLink}
        openDownloadModal={openDownloadModal}
      ></DownloadExcelModal>
    </div>
  );
};

export default ReturnFileActions;
